module.exports = __webpack_public_path__ + "ring-blueprint-hazelnut-ice-cream.0275380483335d2f4959.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/ring-blueprint-hazelnut-ice-cream.svg
// module id = ../../../../../src/assets/img/ring-blueprint-hazelnut-ice-cream.svg
// module chunks = main